import {connect} from "react-redux";
import actions from "../../../../actions";
import UserProfile from './UserProfile';

const mapStateToProps = state => {
    return {
        // categories: state.reducerCategory,
        userState: state.userReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changePasswordUser: (params) => {
            dispatch(actions.changePasswordUserAction(params))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);